import {
  FETCHING_SEEK_ANSWER, FETCHING_SEEK_ANSWER_SUCCEEDED, FETCHING_SEEK_ANSWER_FAILED,
  UPDATING_SEEK_HELPFUL, UPDATING_SEEK_HELPFUL_SUCCEEDED, UPDATING_SEEK_HELPFUL_FAILED,
  INVALIDATE_SEEK_SESSION, FETCHING_SEEK_LIMIT, FETCHING_SEEK_LIMIT_SUCCEEDED, FETCHING_SEEK_LIMIT_FAILED,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE, FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED, FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED,
  FETCH_SEEK_PROMPTS, FETCHING_SEEK_PROMPTS_SUCCEEDED, FETCHING_SEEK_PROMPTS_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';
const initialState = {
  session: {
    loading: false
  },
  item: null,
  error: null,
  emailBody: null,
  prompts: {
    loading: false,
    items: [],
    error: null
  },
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 0,
    totalRecordsCount: 0,
  }
}

function seekReducer(state = initialState, action) {
  switch (action.type) {

    case FETCHING_SEEK_ANSWER: {
      var session = action.payload.session;
      var question = action.payload.question;

      var currentSession = state.session || initialState;

      if (session != null && currentSession.item.id !== session) {
        return state;
      } else if (session == null) {
        currentSession = {
          ...initialState,
          creating: true,
          item: {
            id: null,
            chats: []
          }
        }
      }

      var chats = [...currentSession.item.chats, {
        question: question,
        querying: true
      }];

      return Object.assign({}, state, {
        ...state,
        session: {
          ...currentSession,
          loading: true,
          item: {
            ...currentSession.item,
            chats: chats
          }
        }
      });
    }

    case FETCHING_SEEK_ANSWER_SUCCEEDED: {
      var session = action.payload.session;
      var response = action.payload.response;

      var currentSession = state.session || initialState;
      if (session != null && currentSession.item.id !== session) {
        return state;
      } else if (session == null) {
        currentSession = {
          ...initialState,
          creating: true,
          item: {
            id: response.session,
            chats: []
          }
        }
      }

      var chats = [...currentSession.item.chats].filter(chat => {
        return !chat.querying;
      });

      chats = [...chats, response];

      return Object.assign({}, state, {
        ...state,
        session: {
          ...currentSession,
          loading: false,
          item: {
            ...currentSession.item,
            chats: chats
          }
        }
      });
    }

    case FETCHING_SEEK_ANSWER_FAILED: {
      var session = action.payload.session;
      var error = _.get(session, 'error.errors[0].code');
      var question = action.payload.session.question;

      var currentSession = state.session || initialState;

      var chats = [...currentSession.item.chats].filter(chat => {
        return !chat.querying;
      });

      chats = [...chats, { question: question, error: session.error }];

      return Object.assign({}, state, {
        ...state,
        session: {
          ...currentSession,
          item: {
            ...currentSession.item,
            chats: chats
          },
        }
      });
    }

    case UPDATING_SEEK_HELPFUL:
      var chatId = action.payload.chatId;

      var currentSession = state.session || initialState;
      var chats = _.get(currentSession, 'item.chats');

      if (_.size(chats) == 0) {
        return state;
      }

      chats = chats.map(chat => {
        if (chat.id === chatId) {
          return {
            ...chat,
            updating: true
          }
        }

        return chat;
      })

      return Object.assign({}, state, {
        ...state,
        session: {
          ...currentSession,
          item: {
            ...currentSession.item,
            chats: chats
          }
        }
      });

    case UPDATING_SEEK_HELPFUL_SUCCEEDED:
      var response = action.payload.response;
      var chatId = action.payload.chatId;

      var currentSession = state.session || initialState;
      var chats = _.get(currentSession, 'item.chats');

      if (_.size(chats) == 0) {
        return state;
      }

      chats = chats.map(chat => {
        if (chat.id === chatId) {
          return {
            ...chat,
            updating: false,
            isHelpful: response.isHelpful
          }
        }

        return chat;
      })

      return Object.assign({}, state, {
        ...state,
        session: {
          ...currentSession,
          item: {
            ...currentSession.item,
            chats: chats
          }
        }
      });

    case INVALIDATE_SEEK_SESSION:

      return Object.assign({}, state, {
        session: initialState
      });

          case FETCHING_EMAIL_FOR_SEEK_RESPONSE:
            return {
              ...state,
              session: {
                ...state.session,
                loading: true,
              }
            };
      
          case FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED: {
            const emailBody = action.payload.response?.body || "";
            return {
              ...state,
              session: {
                ...state.session,
                loading: false,
              },
              emailBody,
            };
          }
      
          case FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED: {
            const { error } = action.payload;
            return {
              ...state,
              session: {
                ...state.session,
                loading: false,
              },
              error,
            };
          }

    case FETCHING_SEEK_LIMIT_SUCCEEDED: {
      const response = action.payload;

      const accountLimit = response.accountLimit;
      const userLimit = response.userLimit;

      return Object.assign({}, state, {
        ...state.seek,
        isLimitExceeded: userLimit >= accountLimit
      })
    }

    case FETCHING_SEEK_LIMIT_FAILED:
      return Object.assign({}, state, {
        ...state.seek,
        isLimitExceeded: true
      });

    case FETCH_SEEK_PROMPTS:
      return {
        ...state,
        prompts: {
          ...state.prompts,
          loading: true
        }
      };

    case FETCHING_SEEK_PROMPTS_SUCCEEDED:
      return {
        ...state,
        prompts: {
          ...state.prompts,
          loading: false,
          items: action.payload,
          error: null
        }
      };

    case FETCHING_SEEK_PROMPTS_FAILED:
      return {
        ...state,
        prompts: {
          ...state.prompts,
          loading: false,
          items: [],
          error: action.payload
        }
      };

    default:
      return state;
  }
}

export { seekReducer };